import { useCallback as f } from "react";
import { useAlert as T } from "./index119.mjs";
import { useHotelConfig as b } from "./index93.mjs";
import { getSubscriptionPlanRoot as s } from "./index14.mjs";
import { ERROR_HASH as u } from "./index87.mjs";
import { addTrackingHash as y, removeTrackingHash as A } from "./index118.mjs";
import { track as _ } from "./index9.mjs";
import { TRACK_EVENT_TYPE as m, TRACK_EVENT as a } from "./index10.mjs";
const L = () => {
  const i = T(), { hotelId: o, propertySize: t, propertyType: r, subscriptionPlan: e } = b();
  return f(
    ({
      title: l,
      subTitle: c,
      onClose: n,
      isShowCloseButton: E = !0,
      buttonLabel: g
    } = {}) => {
      y(u), _(a.VIEW, m.BOOKING_FAILED, {
        hotel_id: o,
        property_type: r,
        property_size: t,
        subscription_plan: s(e)
      });
      const p = () => {
        _(
          a.CLICK,
          m.RETURN_AFTER_FAILURE_COMPLETED,
          {
            hotel_id: o,
            property_type: r,
            property_size: t,
            subscription_plan: s(e)
          }
        ), A(), n && n();
      };
      i({
        title: l || I18n.t("booking_engine.information.something_went_wrong"),
        subTitle: c || I18n.t("booking_engine.information.try_again"),
        onClose: p,
        isShowCloseButton: E,
        actions: [
          {
            label: g || I18n.t("booking_engine.information.back_to_payment"),
            onClick: p
          }
        ]
      });
    },
    [o, r, t, e, i]
  );
};
export {
  L as useErrorAlert
};
